export default __webpack_public_path__ + "static/media/jac-logo.fbd7fd2b.png";